import Vue from 'vue';
import Vuex from 'vuex';

// modules
import app from './modules/app';
import current from './modules/current';
import auth from './modules/auth';
import meta from './modules/meta';
import layout from './modules/layout';
import sidebar from './modules/sidebar';
import cache from './modules/cache';
import temp from './modules/temp';
import loader from './modules/loader';
import chat from './modules/chat';

Vue.use(Vuex);

// build the store
export default new Vuex.Store({

    modules: {
        app,
        current,
        auth,
        meta,
        layout,
        sidebar,
        cache,
        temp,
        loader,
        chat,
    },

    strict: process.env.NODE_ENV !== 'production'

});



// WEBPACK FOOTER //
// ./src/js/vuex/store.js